export default __webpack_public_path__ + "static/media/list-icon.b3f7840c.svg";